import axios from "axios";
import { baseUrl } from "../utils/constants";

export const getTrainingMatrixApi = async (userToken) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/get-training-matrix`
        try {
            let response = await axios.get(url, {
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
            resolve(response.data)
        } catch (error) {
            reject(error)
        }
    })
}

export const downloadTrainingMatrixExcelApi = async (userToken) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/download-training-matrix-excel`
        try {
            let response = await axios.get(url, {
                headers: {
                    Authorization: userToken,
                },
                responseType: 'blob'
            })
            resolve(response.data)
        } catch (error) {
            console.log("api error::", error);
            reject(error)
        }
    })
}

export const getAllTicketsApi = async (userToken) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/get-tickets`
        try {
            let response = await axios.get(url, {
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
            resolve(response.data)
        } catch (error) {
            console.log("api error::", error);
            reject(error)
        }
    })
}

export const getUnuploadedAllTicketsApi = async (userToken, sole_trader_id, ticket_id) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/get-unuploaded-tickets?sole_trader_id=${sole_trader_id}&ticket_id=${ticket_id}`
        try {
            let response = await axios.get(url, {
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
            resolve(response.data)
        } catch (error) {
            console.log("api error::", error);
            reject(error)
        }
    })
}

export const addTicketForContractor = async (userToken, params) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/add-ticket`
        try {
            let response = await axios({
                method: "POST",
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                url: url,
                data: {
                    name: params
                }
            })
            resolve(response.data)
        } catch (error) {
            console.log("api error::", error);
            reject(error)
        }
    })
}

export const editTicketForContractor = async (userToken, params) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/edit-ticket`
        try {
            let response = await axios({
                method: "POST",
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                url: url,
                data: params
            })
            resolve(response.data)
        } catch (error) {
            console.log("api error::", error);
            reject(error)
        }
    })
}

export const deleteTicketForContractor = async (userToken, params) => {
    return new Promise(async (resolve, reject) => {
        const url = `${baseUrl}/contractor/delete-ticket/${params}`
        try {
            let response = await axios.delete(url, {
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
            resolve(response.data)
        } catch (error) {
            console.log("api error::", error);
            reject(error)
        }
    })
}

